import Driver from 'driver.js'
import { computed, h } from 'vue'
// import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { Modal } from 'ant-design-vue'

import { getHighlightTextVNode } from '@/utils/highlight-text'
import { version, publishedDate } from '@/constants/guide'
// import { startWoNps } from '@/utils/nps'

export default function useGuide () {
  // const route = useRoute()
  const store = useStore()
  const { t, tm } = useI18n()

  /**
   * 检查是否满足显示引导的条件
   *
   * @param {string[]} preConditions - 前提条件的键名列表
   * @param {string} condition - 本身是否已经显示的键名
   * @returns {boolean}
   */
  // function checkGuideStep (guideName) {
  //   return store.dispatch('checkGuideStep', guideName)
  // }

  const getTranslateOptionText = getTranslateTextFactory('options')

  function getTranslateTextObj (module, keys = ['title', 'description']) {
    const getTranslateText = getTranslateTextFactory(module)
    return keys.reduce((obj, key) => {
      obj[key] = getTranslateText(key)
      return obj
    }, {})
  }

  const defaultOptions = {
    animate: false,
    allowClose: false,
    overlayClickNext: true,
    doneBtnText: getTranslateOptionText('doneBtnText'),
    closeBtnText: getTranslateOptionText('closeBtnText'),
    nextBtnText: getTranslateOptionText('nextBtnText'),
    prevBtnText: getTranslateOptionText('prevBtnText')
  }

  const isNewVersionGuided = computed(() => store.state.guide.isNewVersionGuided)
  // const isLayoutGuided = computed(() => store.state.guide.isLayoutGuided)
  // const isMyObjectiveCreated = computed(() => store.state.guide.isMyObjectiveCreated)
  // const isOtherOkrObjectiveCreated = computed(() => store.state.guide.isOtherOkrObjectiveCreated)
  // const isMyOkrObjectiveAlignGuided = computed(() => store.state.guide.isMyOkrObjectiveAlignGuided)
  // const isOtherOkrAlignGuided = computed(() => store.state.guide.isOtherOkrAlignGuided)

  // watch(isNewVersionGuided, startLayoutGuide)

  // if (route.name === 'MyOkr') {
  //   watch(isLayoutGuided, startMyOkrAlignGuide, {
  //     immediate: true
  //   })
  //   watch(isMyObjectiveCreated, startMyOkrAlignGuide)
  //   watch(isMyOkrObjectiveAlignGuided, startNps, {
  //     immediate: true
  //   })
  // } else if (route.name === 'UserOkr') {
  //   watch(isLayoutGuided, startOtherOkrAlignGuide, {
  //     immediate: true
  //   })
  //   watch(isOtherOkrObjectiveCreated, startOtherOkrAlignGuide)
  //   watch(isOtherOkrAlignGuided, startNps, {
  //     immediate: true
  //   })
  // } else {
  //   watch(isLayoutGuided, startNps, {
  //     immediate: true
  //   })
  // }

  function getTranslateTextFactory (module) {
    return function (key) {
      return t(`guide.${module}.${key}`)
    }
  }

  function showNewVersion () {
    if (isNewVersionGuided.value) {
      return
    }

    Modal.info({
      title: `V${version} ${t('changelog.meta.title')}（${publishedDate}）`,
      content: h('div', { style: { lineHeight: 1.8 } }, [
        h('div', {}, tm('changelog.meta.dear')),
        h('div', {}, tm('changelog.meta.header')),
        ...tm('changelog.sections').map(section =>
          h('div', {}, [
            h('div', { style: { margin: '8px 0', fontWeight: 'bold' } }, section.name),
            ...section.content.map((item, i) => h('div', {}, [
              section.content.length > 1 && (i + 1) + '. ',
              getHighlightTextVNode(item.text, item.highlightStrPos)
            ])).filter(Boolean)
          ])
        ),
        h('div', {}, tm('changelog.meta.footer'))
      ]),
      width: 800,
      onOk () {
        store.dispatch('checkGuidedVersion')
        startLayoutGuide()
      }
    })
  }

  function startLayoutGuide () {
    // const guideName = 'isLayoutGuided'
    const driver = new Driver({
      ...defaultOptions,
      className: 'driver-guide-steps'
      // onReset: () => checkGuideStep(guideName)
    })
    setTimeout(() => {
      driver.defineSteps([
        {
          element: '#weekly-button',
          popover: {
            ...getTranslateTextObj('layout.weeklyBtn'),
            position: 'left'
          }
        },
        {
          element: '#my-team-weekly-btn',
          popover: {
            ...getTranslateTextObj('layout.myTeamWeeklyBtn'),
            position: 'right'
          }
        },
        {
          element: '#my-team-okr',
          popover: {
            ...getTranslateTextObj('layout.myTeamOkr'),
            position: 'right'
          }
        }
      ])
      driver.start()
    }, 600)
  }

  // function startMyOkrAlignGuide () {
  //   const guideName = 'isMyOkrObjectiveAlignGuided'
  //   if (!checkGuideCondition(['isLayoutGuided', 'isMyObjectiveCreated'], guideName)) {
  //     return
  //   }
  //   const driver = new Driver({
  //     ...defaultOptions,
  //     className: 'driver-guide-image-highlight',
  //     onReset: () => checkGuideStep(guideName)
  //   })
  //   const getTranslateText = getTranslateTextFactory('okr.align.self.objective')
  //   setTimeout(() => {
  //     driver.highlight({
  //       element: '#okr-list div:first-child .objective-align',
  //       popover: {
  //         position: 'left',
  //         title: getTranslateText('title'),
  //         description: `
  //       <p>${getTranslateText('description')}</p>
  //       <img
  //         src="${t('guide.okr.align.self.objective.image')}"
  //         alt="how to align"
  //         class="driver-guide-image"
  //        >
  //       <a href="${getTranslateText('doc.url')}" target="_blank">${getTranslateText('doc.text')}</a>
  //     `
  //       }
  //     })
  //   }, 1000)
  // }

  // function startOtherOkrAlignGuide () {
  //   const guideName = 'isOtherOkrAlignGuided'
  //   if (!checkGuideCondition(['isLayoutGuided', 'isOtherOkrObjectiveCreated'], guideName)) {
  //     return
  //   }
  //   const driver = new Driver({
  //     ...defaultOptions,
  //     className: 'driver-guide-highlight',
  //     onReset: () => checkGuideStep(guideName)
  //   })
  //   setTimeout(() => {
  //     driver.defineSteps([
  //       {
  //         element: '#okr-list div:first-child .align-to-myself',
  //         popover: {
  //           position: 'left',
  //           ...getTranslateTextObj('okr.align.other')
  //         }
  //       }
  //     ])
  //     driver.start()
  //   }, 500)
  // }

  // function startNps () {
  //   const key = process.env.VUE_APP_WONPS_KEY
  //   if (!key) {
  //     return
  //   }

  //   setTimeout(() => startWoNps(key, store.state.user.uid), 2000)
  // }

  return {
    showNewVersion
  }
}
